import React from 'react'
import { FaRegFaceSadTear } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import Seo from '../components/Seo';

const Page404 = () => {
  return (
    <>
        <Seo
          path="/404"
          title="Page Not Found"
          description="The page you are looking for does not exist or has moved."
          noindex
        />

<PageHeader title={`Page Not Found `} />
        <div className="max-w-container shape-1 shape-2 relative mx-auto px-4 py-20  my-20 ">
              <div className="mx-auto flex justify-center lg:px-5 lg:-mx-4">
                <div className="w-full lg:w-8/12 px-6">
                  <div
                    className="post-content-404 relative  "
                  >
                    <div className='smilyIcon'><FaRegFaceSadTear />                    </div>
                    <h1>404</h1>
                    <h3>Page Not Found</h3>
                    <Link to={'/'} className='themeBtn backtoHome'>Home to Home</Link>
                  </div>
                </div>
                
              </div>
            </div>
    </>
  )
}

export default Page404